import BaseService from "./Base.Service";

/**
 * Folgas da empresa (feriados regionais, pontes, aniversário da empresa).
 * Zeram — ou reduzem — a jornada esperada no ponto CLT.
 *
 * Os métodos são explícitos (e não os do BaseService) para que os erros de
 * validação do backend cheguem à tela: o update da base engole a exceção.
 */
class CompanyDayOffService extends BaseService {
  constructor() {
    super("company-day-offs");
  }

  async listByYear(year) {
    const { data } = await this.conn.axios.get(
      `/company-day-offs?year=${year}`
    );
    return data;
  }

  async createDayOff(payload) {
    const { data } = await this.conn.axios.post("/company-day-offs", payload);
    return data;
  }

  async updateDayOff(id, payload) {
    const { data } = await this.conn.axios.put(
      `/company-day-offs/${id}`,
      payload
    );
    return data;
  }

  async removeDayOff(id) {
    const { data } = await this.conn.axios.delete(`/company-day-offs/${id}`);
    return data;
  }
}

export default CompanyDayOffService;
